import { Check, X } from 'lucide-react'

interface DoseActionChipsProps {
  onTaken: () => void
  onMissed: () => void
  isLoading?: boolean
}

/**
 * Icon-only circular action chips for marking doses as taken/missed
 * Redesigned from text buttons to 28px circular chips
 */
export function DoseActionChips({
  onTaken,
  onMissed,
  isLoading = false,
}: DoseActionChipsProps) {
  return (
    <div className="dose-action-chips">
      <button
        type="button"
        className="dose-action-chip dose-action-chip--taken"
        onClick={onTaken}
        disabled={isLoading}
        aria-label="Marcar como tomada"
        title="Tomada"
      >
        <Check size={14} />
      </button>
      <button
        type="button"
        className="dose-action-chip dose-action-chip--missed"
        onClick={onMissed}
        disabled={isLoading}
        aria-label="Marcar como omitida"
        title="Omitida"
      >
        <X size={14} />
      </button>
    </div>
  )
}
